export default [
    [{
        "name": "Alabama",
        "Funded Ratio": 0.913
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.9912
    }, {
        "name": "Arizona",
        "Funded Ratio": 1.1131
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.9199
    }, {
        "name": "California",
        "Funded Ratio": 1.0412
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.917
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.6813
    }, {
        "name": "Delaware",
        "Funded Ratio": 1.195
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 1.2011
    }, {
        "name": "Georgia",
        "Funded Ratio": 1.0677
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.8338
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.9754
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.6992
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6489
    }, {
        "name": "Iowa",
        "Funded Ratio": 1.0152
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.8676
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.9461
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.7751
    }, {
        "name": "Maine",
        "Funded Ratio": 0.7458
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.9031
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.8849
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.8831
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.9638
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.8082
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.9266
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.9329
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.8025
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 1.0421
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.9694
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.9193
    }, {
        "name": "New York",
        "Funded Ratio": 1.1661
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.9792
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.9553
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.639
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.8629
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 1.0178
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.7207
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.8909
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.0536
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9741
    }, {
        "name": "Texas",
        "Funded Ratio": 0.9447
    }, {
        "name": "Utah",
        "Funded Ratio": 0.9437
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.9316
    }, {
        "name": "Virginia",
        "Funded Ratio": 1.0067
    }, {
        "name": "Washington",
        "Funded Ratio": 1.6482
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.4508
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.985
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.9367
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.7664
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.823
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.8683
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.8042
    }, {
        "name": "California",
        "Funded Ratio": 0.87
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.7237
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.6612
    }, {
        "name": "Delaware",
        "Funded Ratio": 1.0251
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 1.0193
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.9553
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.7052
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.852
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.5892
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.5763
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8769
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.7581
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.8113
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6708
    }, {
        "name": "Maine",
        "Funded Ratio": 0.6706
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.7753
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.7604
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.718
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8077
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.6839
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.8137
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7604
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.7989
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7234
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.8338
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.7982
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.802
    }, {
        "name": "New York",
        "Funded Ratio": 1.0579
    }, {
        "name": "North Carolina",
        "Funded Ratio": 1.0877
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.8259
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.7324
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.561
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.9296
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.8336
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6086
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.8334
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.0105
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9138
    }, {
        "name": "Texas",
        "Funded Ratio": 0.829
    }, {
        "name": "Utah",
        "Funded Ratio": 0.7948
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.853
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.848
    }, {
        "name": "Washington",
        "Funded Ratio": 1.3734
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.4034
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.8679
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.7687
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.8043
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.7828
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.7884
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.7743
    }, {
        "name": "California",
        "Funded Ratio": 0.8114
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.7646
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.6013
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.9697
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.9899
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.9381
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.6432
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.8407
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.5641
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6064
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8519
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.708
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.7702
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6395
    }, {
        "name": "Maine",
        "Funded Ratio": 0.6662
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.7626
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.6173
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.7459
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.7539
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.6522
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.7936
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7454
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.7833
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7202
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.7467
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.7257
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.7666
    }, {
        "name": "New York",
        "Funded Ratio": 0.9458
    }, {
        "name": "North Carolina",
        "Funded Ratio": 1.0755
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.7878
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.7677
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.5727
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.9511
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.8334
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.5556
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.819
    }, {
        "name": "South Dakota",
        "Funded Ratio": 0.9928
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9119
    }, {
        "name": "Texas",
        "Funded Ratio": 0.8442
    }, {
        "name": "Utah",
        "Funded Ratio": 0.939
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.8422
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.8041
    }, {
        "name": "Washington",
        "Funded Ratio": 1.2186
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.3917
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.9828
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.8469
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.8099
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.8277
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.8374
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.8256
    }, {
        "name": "California",
        "Funded Ratio": 0.8775
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.8101
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.628
    }, {
        "name": "Delaware",
        "Funded Ratio": 1.0037
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 1.0604
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.959
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.698
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.9193
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.6712
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6525
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8999
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.7221
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.773
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6937
    }, {
        "name": "Maine",
        "Funded Ratio": 0.7312
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.8322
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.7064
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.7806
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8035
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.6882
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.8295
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7834
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.8378
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7487
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.7852
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.7369
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.815
    }, {
        "name": "New York",
        "Funded Ratio": 1.0649
    }, {
        "name": "North Carolina",
        "Funded Ratio": 1.1096
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.8595
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.8183
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.5849
    }, {
        "name": "Oregon",
        "Funded Ratio": 1.0212
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.8849
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6055
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.8157
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.0924
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9443
    }, {
        "name": "Texas",
        "Funded Ratio": 0.8901
    }, {
        "name": "Utah",
        "Funded Ratio": 0.9886
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.9137
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.8596
    }, {
        "name": "Washington",
        "Funded Ratio": 1.2615
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.4387
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.0189
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.9575
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.7912
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.8196
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.8088
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.8255
    }, {
        "name": "California",
        "Funded Ratio": 0.9263
    }, {
        "name": "Colorado",
        "Funded Ratio": 1.4247
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.6244
    }, {
        "name": "Delaware",
        "Funded Ratio": 1.0065
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 1.0412
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.9475
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.7081
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.9437
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.6676
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6481
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.9266
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.7207
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.7452
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.7131
    }, {
        "name": "Maine",
        "Funded Ratio": 0.764
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.8219
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.7528
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.8094
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8157
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.7119
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.8448
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7906
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.8651
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7517
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.7148
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.7099
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.8174
    }, {
        "name": "New York",
        "Funded Ratio": 1.092
    }, {
        "name": "North Carolina",
        "Funded Ratio": 1.1225
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.8908
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.8369
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.6165
    }, {
        "name": "Oregon",
        "Funded Ratio": 1.0351
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.8992
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6215
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.738
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.1056
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.968
    }, {
        "name": "Texas",
        "Funded Ratio": 0.9247
    }, {
        "name": "Utah",
        "Funded Ratio": 1.013
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.9304
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.8391
    }, {
        "name": "Washington",
        "Funded Ratio": 1.2401
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.4706
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.0361
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.9744
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.7968
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.7713
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.8127
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.8545
    }, {
        "name": "California",
        "Funded Ratio": 0.951
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.7804
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.6333
    }, {
        "name": "Delaware",
        "Funded Ratio": 1.0392
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 1.0483
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.9231
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.6775
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.954
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.6785
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6648
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.9441
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.749
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.6955
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.7474
    }, {
        "name": "Maine",
        "Funded Ratio": 0.7711
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.796
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.8229
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.8604
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8267
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.7349
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.8511
    }, {
        "name": "Montana",
        "Funded Ratio": 0.8187
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.9075
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7593
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.7288
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.6986
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.837
    }, {
        "name": "New York",
        "Funded Ratio": 1.1533
    }, {
        "name": "North Carolina",
        "Funded Ratio": 1.0998
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.9306
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.8807
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.6189
    }, {
        "name": "Oregon",
        "Funded Ratio": 1.1024
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.9426
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6231
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.7102
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.168
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9475
    }, {
        "name": "Texas",
        "Funded Ratio": 0.9366
    }, {
        "name": "Utah",
        "Funded Ratio": 1.0714
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.9212
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.8712
    }, {
        "name": "Washington",
        "Funded Ratio": 1.2941
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.5272
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.0903
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.9998
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.8429
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.8205
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.867
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.9516
    }, {
        "name": "California",
        "Funded Ratio": 1.0324
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.7838
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.6557
    }, {
        "name": "Delaware",
        "Funded Ratio": 1.1145
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 1.1299
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.9659
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.7303
    }, {
        "name": "Idaho",
        "Funded Ratio": 1.0573
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.6951
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.7117
    }, {
        "name": "Iowa",
        "Funded Ratio": 1.0054
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.8064
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.7305
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.797
    }, {
        "name": "Maine",
        "Funded Ratio": 0.8383
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.8394
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.9106
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.9242
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8939
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.7949
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.9099
    }, {
        "name": "Montana",
        "Funded Ratio": 0.8993
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.9937
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.8204
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.7983
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.7349
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.8972
    }, {
        "name": "New York",
        "Funded Ratio": 1.2214
    }, {
        "name": "North Carolina",
        "Funded Ratio": 1.157
    }, {
        "name": "North Dakota",
        "Funded Ratio": 1.0234
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.9388
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.6807
    }, {
        "name": "Oregon",
        "Funded Ratio": 1.2271
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 1.0481
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6871
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.7426
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.2142
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9893
    }, {
        "name": "Texas",
        "Funded Ratio": 0.958
    }, {
        "name": "Utah",
        "Funded Ratio": 1.0033
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.9864
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.9455
    }, {
        "name": "Washington",
        "Funded Ratio": 1.46
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.688
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.0572
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.9589
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.6707
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.7289
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.7501
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.838
    }, {
        "name": "California",
        "Funded Ratio": 0.9034
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.5267
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.5967
    }, {
        "name": "Delaware",
        "Funded Ratio": 1.014
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 1.0031
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.8452
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.6554
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.9346
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.5737
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6479
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.9108
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.6927
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.622
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6906
    }, {
        "name": "Maine",
        "Funded Ratio": 0.7671
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.7304
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.8285
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6957
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8017
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.6747
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.8083
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7946
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.8594
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7279
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.6936
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.6574
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.7753
    }, {
        "name": "New York",
        "Funded Ratio": 1.1231
    }, {
        "name": "North Carolina",
        "Funded Ratio": 1.0319
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.8867
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.714
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.5776
    }, {
        "name": "Oregon",
        "Funded Ratio": 1.0972
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.8099
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6371
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.6614
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.0481
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9316
    }, {
        "name": "Texas",
        "Funded Ratio": 0.8305
    }, {
        "name": "Utah",
        "Funded Ratio": 0.7063
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.8202
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.8272
    }, {
        "name": "Washington",
        "Funded Ratio": 1.2955
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.5653
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.7677
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.655
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.5764
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.5068
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.5726
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.6276
    }, {
        "name": "California",
        "Funded Ratio": 0.6279
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.599
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.4501
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.7899
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.7141
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.705
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.4998
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.7422
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.4626
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.5094
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.6874
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.508
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.4675
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.5287
    }, {
        "name": "Maine",
        "Funded Ratio": 0.5767
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.5442
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.5812
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6086
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.5934
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.4947
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.6094
    }, {
        "name": "Montana",
        "Funded Ratio": 0.5807
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.6507
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.5675
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.5092
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.4994
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.5526
    }, {
        "name": "New York",
        "Funded Ratio": 0.7879
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.821
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.6049
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.6349
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.4598
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.7907
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.6115
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.4707
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.4878
    }, {
        "name": "South Dakota",
        "Funded Ratio": 0.7646
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.7492
    }, {
        "name": "Texas",
        "Funded Ratio": 0.719
    }, {
        "name": "Utah",
        "Funded Ratio": 0.7421
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.607
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.6014
    }, {
        "name": "Washington",
        "Funded Ratio": 0.9196
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.5025
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.8849
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.7575
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.5921
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.495
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.6056
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.6642
    }, {
        "name": "California",
        "Funded Ratio": 0.6628
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.6327
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.4642
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.8327
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.7798
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.712
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.5315
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.7911
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.469
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.5442
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.7444
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.5371
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.4819
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.5568
    }, {
        "name": "Maine",
        "Funded Ratio": 0.6128
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.5932
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.6084
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.5965
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.6925
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.5347
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.6485
    }, {
        "name": "Montana",
        "Funded Ratio": 0.5979
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.6954
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.596
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.5414
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.5831
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.6092
    }, {
        "name": "New York",
        "Funded Ratio": 0.862
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.8498
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.601
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.67
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.4888
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.8394
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.6093
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.4365
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.5165
    }, {
        "name": "South Dakota",
        "Funded Ratio": 0.8787
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.7593
    }, {
        "name": "Texas",
        "Funded Ratio": 0.7463
    }, {
        "name": "Utah",
        "Funded Ratio": 0.7861
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.6862
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.6133
    }, {
        "name": "Washington",
        "Funded Ratio": 0.9609
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.5629
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.9395
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.8016
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.5767
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.5487
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.6941
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.761
    }, {
        "name": "California",
        "Funded Ratio": 0.7464
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.5999
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.5253
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.935
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.8728
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.8038
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.5799
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.9039
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.4998
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6127
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8129
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.6155
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.5344
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6439
    }, {
        "name": "Maine",
        "Funded Ratio": 0.7969
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.6759
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.6867
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.5544
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.7969
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.624
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.7987
    }, {
        "name": "Montana",
        "Funded Ratio": 0.6865
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.8036
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.6849
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.5858
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.6031
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.672
    }, {
        "name": "New York",
        "Funded Ratio": 0.9424
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.9457
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.6846
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.6749
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.6744
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.9404
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.5944
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6142
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.5961
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.029
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.8401
    }, {
        "name": "Texas",
        "Funded Ratio": 0.7822
    }, {
        "name": "Utah",
        "Funded Ratio": 0.7614
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.7412
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.6821
    }, {
        "name": "Washington",
        "Funded Ratio": 1.0827
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.643
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.9351
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.7557
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.6678
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.5118
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.6465
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.7068
    }, {
        "name": "California",
        "Funded Ratio": 0.7053
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.6321
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.4724
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.87
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.8104
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.7649
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.546
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.8487
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.4721
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.5818
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.7836
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.5789
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.4939
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6124
    }, {
        "name": "Maine",
        "Funded Ratio": 0.7525
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.6444
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.6272
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6076
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.7509
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.5735
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.7614
    }, {
        "name": "Montana",
        "Funded Ratio": 0.6543
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.7541
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.6709
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.555
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.563
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.6272
    }, {
        "name": "New York",
        "Funded Ratio": 0.9233
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.9087
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.6306
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.6721
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.6439
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.8768
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.5695
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.5885
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.5535
    }, {
        "name": "South Dakota",
        "Funded Ratio": 0.9278
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.8517
    }, {
        "name": "Texas",
        "Funded Ratio": 0.7911
    }, {
        "name": "Utah",
        "Funded Ratio": 0.8061
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.6922
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.6456
    }, {
        "name": "Washington",
        "Funded Ratio": 1.0332
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.6258
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.0304
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.8067
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.6993
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.5381
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.6825
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.7705
    }, {
        "name": "California",
        "Funded Ratio": 0.7235
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.6408
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.4955
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.8958
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.8413
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.7939
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.5796
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.8551
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.5097
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.5988
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.813
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.6115
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.505
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.648
    }, {
        "name": "Maine",
        "Funded Ratio": 0.7881
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.6744
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.639
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.637
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8042
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.6102
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.8001
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7673
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.8105
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.6868
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.5981
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.5723
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.6852
    }, {
        "name": "New York",
        "Funded Ratio": 0.9626
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.9361
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.6646
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.7607
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.7069
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.9681
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.5769
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6103
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.5616
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.032
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.8962
    }, {
        "name": "Texas",
        "Funded Ratio": 0.8023
    }, {
        "name": "Utah",
        "Funded Ratio": 0.882
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.6963
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.6952
    }, {
        "name": "Washington",
        "Funded Ratio": 1.0112
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.6786
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.0539
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.811
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.7248
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.5789
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.7259
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.8553
    }, {
        "name": "California",
        "Funded Ratio": 0.7941
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.6317
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.5317
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.9602
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.9368
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.8598
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.6392
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.9409
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.5164
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.647
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8751
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.6797
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.5367
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6772
    }, {
        "name": "Maine",
        "Funded Ratio": 0.8556
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.7271
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.6926
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6657
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8504
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.6721
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.8731
    }, {
        "name": "Montana",
        "Funded Ratio": 0.756
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.9065
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7631
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.6691
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.5915
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.7416
    }, {
        "name": "New York",
        "Funded Ratio": 1.0227
    }, {
        "name": "North Carolina",
        "Funded Ratio": 1.0137
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.7195
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.7905
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.813
    }, {
        "name": "Oregon",
        "Funded Ratio": 1.0449
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.5918
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6418
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.6091
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.0729
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9922
    }, {
        "name": "Texas",
        "Funded Ratio": 0.8384
    }, {
        "name": "Utah",
        "Funded Ratio": 0.8988
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.7384
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.7579
    }, {
        "name": "Washington",
        "Funded Ratio": 0.9966
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.7601
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.0308
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.7971
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.679
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.6795
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.7009
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.8234
    }, {
        "name": "California",
        "Funded Ratio": 0.762
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.5902
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.5087
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.9292
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.8967
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.7985
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.6242
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.9058
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.4987
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.5962
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8503
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.662
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.5012
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6557
    }, {
        "name": "Maine",
        "Funded Ratio": 0.8244
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.6942
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.6359
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6267
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8176
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.617
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.8331
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7418
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.8986
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7513
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.6104
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.5576
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.6998
    }, {
        "name": "New York",
        "Funded Ratio": 0.9911
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.9737
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.6942
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.7504
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.7883
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.8838
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.5567
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.605
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.5788
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.041
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9702
    }, {
        "name": "Texas",
        "Funded Ratio": 0.7797
    }, {
        "name": "Utah",
        "Funded Ratio": 0.8442
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.6674
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.7564
    }, {
        "name": "Washington",
        "Funded Ratio": 0.9596
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.7568
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.967
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.7377
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.684
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.6334
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.65
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.7701
    }, {
        "name": "California",
        "Funded Ratio": 0.7014
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.5535
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.438
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.8394
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.8322
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.7154
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.5128
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.8652
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.4618
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.5828
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8154
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.6626
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.4506
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6235
    }, {
        "name": "Maine",
        "Funded Ratio": 0.7719
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.6725
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.5856
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6108
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.7502
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.5747
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.7846
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7081
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.8654
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7223
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.5839
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.495
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.6672
    }, {
        "name": "New York",
        "Funded Ratio": 0.9326
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.8972
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.6498
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.708
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.7179
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.8148
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.5231
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.5671
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.5316
    }, {
        "name": "South Dakota",
        "Funded Ratio": 0.9689
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9436
    }, {
        "name": "Texas",
        "Funded Ratio": 0.7772
    }, {
        "name": "Utah",
        "Funded Ratio": 0.8464
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.6321
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.7341
    }, {
        "name": "Washington",
        "Funded Ratio": 0.9112
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.7108
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.9703
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.7388
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.708
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.6772
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.6359
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.7892
    }, {
        "name": "California",
        "Funded Ratio": 0.726
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.6421
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.4744
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.8479
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.8627
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.744
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.548
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.8988
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.496
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6014
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8209
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.6821
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.4534
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.678
    }, {
        "name": "Maine",
        "Funded Ratio": 0.8181
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.7034
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.6105
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6285
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8047
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.6149
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.7971
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7131
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.8725
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7442
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.6249
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.4899
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.6816
    }, {
        "name": "New York",
        "Funded Ratio": 0.9613
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.9222
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.682
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.7847
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.7751
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.8197
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.557
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.5629
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.5408
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.0008
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9676
    }, {
        "name": "Texas",
        "Funded Ratio": 0.8182
    }, {
        "name": "Utah",
        "Funded Ratio": 0.9075
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.6271
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.7808
    }, {
        "name": "Washington",
        "Funded Ratio": 0.9772
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.7788
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.0355
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.7674
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.7231
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.6754
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.6528
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.825
    }, {
        "name": "California",
        "Funded Ratio": 0.7342
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.5724
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.4804
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.8674
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.8669
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.7763
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.5548
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.9069
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.4801
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6032
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8343
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.6996
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.4683
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6892
    }, {
        "name": "Maine",
        "Funded Ratio": 0.8439
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.7175
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.6165
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.614
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8214
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.6254
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.802
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7229
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.895
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7524
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.6449
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.5025
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.6746
    }, {
        "name": "New York",
        "Funded Ratio": 0.987
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.9014
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.7032
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.7457
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.809
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.8248
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.5445
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.5725
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.5486
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.0002
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9861
    }, {
        "name": "Texas",
        "Funded Ratio": 0.7776
    }, {
        "name": "Utah",
        "Funded Ratio": 0.8501
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.6321
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.7916
    }, {
        "name": "Washington",
        "Funded Ratio": 0.9937
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.8149
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.9538
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.6922
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.6849
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.6689
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.6485
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.8093
    }, {
        "name": "California",
        "Funded Ratio": 0.7334
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.65
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.4663
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.8468
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.8549
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.7722
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.5487
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.9255
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.4983
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6267
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8503
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.7096
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.4588
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.694
    }, {
        "name": "Maine",
        "Funded Ratio": 0.8418
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.727
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.6044
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6114
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8254
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.6131
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.8027
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7177
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.9091
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7646
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.6108
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.4737
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.6686
    }, {
        "name": "New York",
        "Funded Ratio": 0.9785
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.8991
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.6914
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.7832
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.8036
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.8109
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.576
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.5776
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.551
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.0009
    }, {
        "name": "Tennessee",
        "Funded Ratio": 1.0097
    }, {
        "name": "Texas",
        "Funded Ratio": 0.7793
    }, {
        "name": "Utah",
        "Funded Ratio": 0.9076
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.6299
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.7807
    }, {
        "name": "Washington",
        "Funded Ratio": 1.0114
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.815
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.0522
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.7641
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.6795
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.6562
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.6147
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.758
    }, {
        "name": "California",
        "Funded Ratio": 0.7325
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.6864
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.4396
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.867
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.8067
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.7539
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.5318
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.8792
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.5021
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6343
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8241
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.6873
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.4543
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.6671
    }, {
        "name": "Maine",
        "Funded Ratio": 0.8239
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.717
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.576
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6153
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.8097
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.5876
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.7769
    }, {
        "name": "Montana",
        "Funded Ratio": 0.6885
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.8871
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7704
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.5874
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.4485
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.6144
    }, {
        "name": "New York",
        "Funded Ratio": 0.8967
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.8815
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.6523
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.7968
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.7309
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.7638
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.584
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.5753
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.5156
    }, {
        "name": "South Dakota",
        "Funded Ratio": 0.9968
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.9961
    }, {
        "name": "Texas",
        "Funded Ratio": 0.7775
    }, {
        "name": "Utah",
        "Funded Ratio": 0.9461
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.5764
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.7503
    }, {
        "name": "Washington",
        "Funded Ratio": 0.994
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.7903
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.0939
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.7922
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.7794
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.8062
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.7319
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.9542
    }, {
        "name": "California",
        "Funded Ratio": 0.8699
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.722
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.5326
    }, {
        "name": "Delaware",
        "Funded Ratio": 1.0993
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.964
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.9167
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.6503
    }, {
        "name": "Idaho",
        "Funded Ratio": 1.001
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.5821
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.7435
    }, {
        "name": "Iowa",
        "Funded Ratio": 1.0026
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.8158
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.534
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.824
    }, {
        "name": "Maine",
        "Funded Ratio": 0.9274
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.8308
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.697
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6791
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.9921
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.7015
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.9113
    }, {
        "name": "Montana",
        "Funded Ratio": 0.8219
    }, {
        "name": "Nebraska",
        "Funded Ratio": 1.0616
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.8651
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.7174
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.5472
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.738
    }, {
        "name": "New York",
        "Funded Ratio": 1.1273
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.9993
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.7753
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.8676
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.9082
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.9149
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.6674
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6958
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.6226
    }, {
        "name": "South Dakota",
        "Funded Ratio": 1.0553
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.8177
    }, {
        "name": "Texas",
        "Funded Ratio": 0.8757
    }, {
        "name": "Utah",
        "Funded Ratio": 0.9709
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.6795
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.9431
    }, {
        "name": "Washington",
        "Funded Ratio": 1.2165
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.9858
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 1.1299
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.8141
    }],
    [{
        "name": "Alabama",
        "Funded Ratio": 0.6864
    }, {
        "name": "Alaska",
        "Funded Ratio": 0.7162
    }, {
        "name": "Arizona",
        "Funded Ratio": 0.6531
    }, {
        "name": "Arkansas",
        "Funded Ratio": 0.8424
    }, {
        "name": "California",
        "Funded Ratio": 0.779
    }, {
        "name": "Colorado",
        "Funded Ratio": 0.6415
    }, {
        "name": "Connecticut",
        "Funded Ratio": 0.4846
    }, {
        "name": "Delaware",
        "Funded Ratio": 0.9759
    },  {
        "name": "District of Columbia"
    }, {
        "name": "Florida",
        "Funded Ratio": 0.852
    }, {
        "name": "Georgia",
        "Funded Ratio": 0.8141
    }, {
        "name": "Hawaii",
        "Funded Ratio": 0.5825
    }, {
        "name": "Idaho",
        "Funded Ratio": 0.8862
    }, {
        "name": "Illinois",
        "Funded Ratio": 0.5208
    }, {
        "name": "Indiana",
        "Funded Ratio": 0.6816
    }, {
        "name": "Iowa",
        "Funded Ratio": 0.8862
    }, {
        "name": "Kansas",
        "Funded Ratio": 0.7293
    }, {
        "name": "Kentucky",
        "Funded Ratio": 0.4691
    }, {
        "name": "Louisiana",
        "Funded Ratio": 0.738
    }, {
        "name": "Maine",
        "Funded Ratio": 0.8319
    }, {
        "name": "Maryland",
        "Funded Ratio": 0.7433
    }, {
        "name": "Massachusetts",
        "Funded Ratio": 0.6164
    }, {
        "name": "Michigan",
        "Funded Ratio": 0.6074
    }, {
        "name": "Minnesota",
        "Funded Ratio": 0.873
    }, {
        "name": "Mississippi",
        "Funded Ratio": 0.6166
    }, {
        "name": "Missouri",
        "Funded Ratio": 0.8075
    }, {
        "name": "Montana",
        "Funded Ratio": 0.7259
    }, {
        "name": "Nebraska",
        "Funded Ratio": 0.934
    }, {
        "name": "Nevada",
        "Funded Ratio": 0.7495
    }, {
        "name": "New Hampshire",
        "Funded Ratio": 0.6453
    }, {
        "name": "New Jersey",
        "Funded Ratio": 0.4916
    }, {
        "name": "New Mexico",
        "Funded Ratio": 0.6546
    }, {
        "name": "New York",
        "Funded Ratio": 0.9941
    }, {
        "name": "North Carolina",
        "Funded Ratio": 0.8979
    }, {
        "name": "North Dakota",
        "Funded Ratio": 0.6927
    }, {
        "name": "Ohio",
        "Funded Ratio": 0.7656
    }, {
        "name": "Oklahoma",
        "Funded Ratio": 0.8083
    }, {
        "name": "Oregon",
        "Funded Ratio": 0.8003
    }, {
        "name": "Pennsylvania",
        "Funded Ratio": 0.6027
    }, {
        "name": "Rhode Island",
        "Funded Ratio": 0.6261
    }, {
        "name": "South Carolina",
        "Funded Ratio": 0.5595
    }, {
        "name": "South Dakota",
        "Funded Ratio": 0.9336
    }, {
        "name": "Tennessee",
        "Funded Ratio": 0.7192
    }, {
        "name": "Texas",
        "Funded Ratio": 0.7762
    }, {
        "name": "Utah",
        "Funded Ratio": 0.8547
    }, {
        "name": "Vermont",
        "Funded Ratio": 0.6157
    }, {
        "name": "Virginia",
        "Funded Ratio": 0.8414
    }, {
        "name": "Washington",
        "Funded Ratio": 1.0738
    }, {
        "name": "West Virginia",
        "Funded Ratio": 0.8737
    }, {
        "name": "Wisconsin",
        "Funded Ratio": 0.9958
    }, {
        "name": "Wyoming",
        "Funded Ratio": 0.722
    }]
]